import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const ChannelVerizon = ({ monochrome, ...restProps }) => (
  <SvgIcon {...restProps} viewBox="0 0 16 16">
    <circle
      cx="8"
      cy="8"
      r="7.9"
      fill={monochrome ? 'currentColor' : 'black'}
    />

    <g transform="translate(-0.5)" fill={monochrome ? 'white' : '#d32e2a'}>
      <path d="M11.0102 2L6.76419 11.2641L5.13213 8H3.45508L6.12278 13.3354L6.20508 13.5H7.38946L7.4754 13.3125L12.6603 2H11.0102Z" />
    </g>
  </SvgIcon>
);

ChannelVerizon.propTypes = {
  monochrome: PropTypes.bool,
};
ChannelVerizon.defaultProps = {
  monochrome: false,
};

export default ChannelVerizon;
